import React from 'react';
import { NumberInput, ReferenceInput, SelectInput } from 'react-admin';
import { RowForm } from '@react-admin/ra-editable-datagrid';
import PercentageInput from '../../base/input/PercentageInput';

const OverheadForm = (props) => {
    return (
        <RowForm {...props}>
            <PercentageInput source="value" label="Overhead Factor" />
            <NumberInput source="year" />
            <ReferenceInput
                label="Supervision Role"
                source="supervision_role"
                reference="users/supervision-role"
            >
                <SelectInput style={{ minWidth: 200 }} optionText="name" />
            </ReferenceInput>
        </RowForm>
    );
};

export default OverheadForm;
